export default {
  bindings: {
    show: '<',
  },
  template: `
    <div ng-show="ctrl.show" class="sling-animate markdown-hints">
      <span># headings</span>
      <span>**bold**</span>
      <span>*italic*</span>
      <span>~~strike~~</span>
      <span>&gt; quote</span>
      <span>--- divider</span>
    </div>
  `,
  controllerAs: 'ctrl',
};
